import type { SymbolDto } from '../../contracts/api'
import { withAlpha } from '../colors'

/**
 * Герб символа: круг с обводкой своим цветом и глиф внутри. Рисуем SVG, а не
 * div с border-radius, потому что глиф обязан стоять точно по центру круга при
 * любом кегле — иероглиф, латиница и цифра сидят на разных базовых линиях, и
 * только `dominant-baseline` кладёт их одинаково.
 */
export function SymbolCrest({ symbol, size }: { symbol: SymbolDto; size: number }) {
  const glyph = symbol.glyph || '·'
  const fontSize = glyph.length > 2 ? 26 : glyph.length === 2 ? 34 : 44

  return (
    <svg
      className="crest"
      width={size}
      height={size}
      viewBox="0 0 100 100"
      role="img"
      aria-label={symbol.title}
    >
      <circle cx="50" cy="50" r="43" fill={withAlpha(symbol.color, 0.12)} stroke={symbol.color} strokeWidth="1.8" />
      <circle cx="50" cy="50" r="35" fill="none" stroke={withAlpha(symbol.color, 0.32)} strokeWidth="1.5" />
      <text
        className="crest-glyph"
        x="50"
        y="51"
        textAnchor="middle"
        dominantBaseline="central"
        fill={symbol.color}
        fontSize={fontSize}
      >
        {glyph}
      </text>
    </svg>
  )
}
